import { Check, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { colors } from '../constants/designTokens';

export const PricingCard = ({ 
  tier, 
  price, 
  duration, 
  features = [], 
  highlighted = false,
  onCTAClick 
}) => {
  return (
    <div 
      className={`relative bg-white rounded-xl border-2 p-8 hover:-translate-y-1 transition-all duration-200 ${
        highlighted 
          ? 'border-[#F97316] shadow-xl shadow-orange-100' 
          : 'border-gray-200 shadow-sm hover:shadow-lg'
      }`}
      data-testid={`pricing-card-${tier.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {highlighted && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#F59E0B] text-white px-4 py-1 rounded-full text-sm font-semibold uppercase tracking-wide">
          Most Popular
        </div>
      )}
      
      <div className="text-center mb-6">
        <h3 className="text-sm font-semibold text-[#475569] uppercase tracking-wider mb-2">
          {tier}
        </h3>
        <div className="text-4xl font-bold text-[#0F172A] mb-2">
          {price}
        </div>
        <p className="text-sm text-[#475569]">{duration}</p>
      </div>
      
      <ul className="space-y-3 mb-8">
        {features.map((feature, idx) => (
          <li key={idx} className="flex items-start gap-3">
            <Check className="h-5 w-5 text-[#2563EB] flex-shrink-0 mt-0.5" />
            <span className="text-[#475569]">{feature}</span>
          </li>
        ))}
      </ul>
      
      <Button 
        onClick={onCTAClick}
        className={`w-full ${
          highlighted 
            ? 'bg-[#F97316] hover:bg-[#EA580C] text-white shadow-md' 
            : 'bg-[#2563EB] hover:bg-[#1D4ED8] text-white'
        }`}
        data-testid={`pricing-cta-${tier.toLowerCase().replace(/\s+/g, '-')}`}
      >
        Get This Quote
        <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
    </div>
  );
};
